import { useEffect } from 'react';

const useAdScriptsSequentiallyWithWait = (scripts = [], options = {}) => {
  const delay = options.delay || 1500;
  const waitForSelector = options.waitForSelector; // e.g. "#ad-slot"

  useEffect(() => {
    const waitForElement = (selector, timeout = 5000) => {
      return new Promise((resolve) => {
        const interval = 100;
        let elapsed = 0;

        const check = setInterval(() => {
          if (document.querySelector(selector)) {
            clearInterval(check);
            resolve(true);
          }
          elapsed += interval;
          if (elapsed >= timeout) {
            clearInterval(check);
            console.warn(`⚠️ Element ${selector} not found in time`);
            resolve(false);
          }
        }, interval);
      });
    };

    const injectScript = async ({ src, domain, zone, path = '401', selectorToWaitFor }) => {
      if (selectorToWaitFor) {
        const found = await waitForElement(selectorToWaitFor);
        if (!found) {
          console.warn(`⚠️ Skipping ${domain}/${zone} — selector ${selectorToWaitFor} not found.`);
          return;
        }
      }

      return new Promise((resolve) => {
        const script = document.createElement('script');
        if (src) {
          script.src = src;
        } else {
          script.src = `https://${domain}/${path}/${zone}`;
        }

        script.async = true;

        script.onload = () => {
          console.log(`✅ Script loaded from ${domain} (${zone})`);
          resolve();
        };

        script.onerror = () => {
          console.warn(`❌ Failed to load script from ${domain}`);
          resolve(); // continue anyway
        };

        document.body.appendChild(script);
      });
    };


    const loadInSequence = async () => {
      for (const script of scripts) {
        await injectScript(script);
        await new Promise((res) => setTimeout(res, delay));
      }
    };

    loadInSequence();
  }, [scripts, delay, waitForSelector]);
};

export default useAdScriptsSequentiallyWithWait;
